import * as React from 'react';
import classNames from 'classnames';

import * as styles from './Navigation.css';

type TNavigationIndent = 'M' | 'L';

const INDENT_TO_CLASS: { [key in TNavigationIndent]: string } = {
  M: styles['middle-indent'],
  L: styles['large-indent'],
};

export interface INavigationProps {
  children: React.ReactNode;
  indent?: TNavigationIndent;
}

export function Navigation({ children, indent = 'M' }: INavigationProps) {
  return <div className={classNames(styles['container'], INDENT_TO_CLASS[indent])}>{children}</div>;
}
